// @flow
import geoViewport from '@mapbox/geo-viewport';

import * as types from '../types/map';
import type {
  SET_MAP_POSITION_TYPE,
  MAP_PRISTINE_SET_TYPE,
  MAP_DIRTY_SET_TYPE,
  MAP_SET_LOADING_TYPE,
  MAP_COMPLETED_LOADING_TYPE,
} from '../types/map';


export const setMapPosition = (
  zoom: number,
  longitude: number,
  latitude: number,
  animate: boolean,
  offset?: Object = {},
): SET_MAP_POSITION_TYPE => {
  // Needed to round zoom because this library doesnt support decimal zoom
  const integerZoom = parseInt(Math.round(zoom), 10);

  const [
    nwLongitude,
    nwLatitude,
    seLongitude,
    seLatitude,
  ] = geoViewport.bounds(
    [longitude, latitude],
    integerZoom,
    [window.innerWidth, window.innerHeight],
  );

  const deltaLongitude = (seLongitude - nwLongitude) / 4.0;
  const deltaLatitude = (seLatitude - nwLatitude) / 4.0;

  // The / 2.0 only works to bound the offsets to [-1, 1]
  return {
    type: types.SET_MAP_POSITION,
    payload: {
      zoom: integerZoom,
      longitude: longitude + (offset.longitude || 0.0) * deltaLongitude,
      latitude: latitude + (offset.latitude || 0.0) * deltaLatitude,
      animate,
    },
  };
};

export const setMapPristine = (): MAP_PRISTINE_SET_TYPE => ({
  type: types.MAP_PRISTINE_SET,
});

export const setMapDirty = (): MAP_DIRTY_SET_TYPE => ({
  type: types.MAP_DIRTY_SET,
});

export const setMapLoading = (message: string): MAP_SET_LOADING_TYPE => ({
  type: types.MAP_SET_LOADING,
  payload: message,
});

export const unsetMapLoading = (): MAP_COMPLETED_LOADING_TYPE => ({
  type: types.MAP_COMPLETED_LOADING,
});



// WEBPACK FOOTER //
// ./src/scripts/actions/map.js